<div class="modal-container">
	<h6 class="mb-4 text-uppercase">{{ "KEY.KEY" | translate }}</h6>
	<div class="mb-3">
		<img
			style="height: 40px; max-width: 100%"
			class="mr-4 ml-2"
			src="{{ pathImgsMarkers }}/ico-pop-legenda.png?v={{ assets_version }}"
			alt=""
		/>
		<span class="key-text text-uppercase ml-1">{{ "KEY.POPS" | translate }}</span>
	</div>
	<div class="mb-3">
		<img
			class="mr-4"
			style="width: 30px; margin-left: 0.5rem"
			src="{{ pathImgsMarkers }}/ico-pop-cd-legenda.png?v={{ assets_version }}"
			alt=""
		/>
		<span class="key-text text-uppercase">{{ "KEY.PCN" | translate }}</span>
	</div>
	<div class="mb-3">
		<img
			class="key-image mr-4"
			src="{{ pathImgsMarkers }}/ico-mappa-copertura-legenda.png?v={{ assets_version }}"
			srcset="{{pathImgsMarkers}}/ico-mappa-copertura-legenda@2x.png 2x"
			alt=""
		/>
		<span class="key-text text-uppercase">{{ "KEY.COVERAGE_AB" | translate }}</span>
	</div>
	<div class="mb-3">
		<img class="key-image mr-4" src="{{ pathImgsMarkers }}/ico-cd-map.png?v={{ assets_version }}" alt="" />
		<span class="key-text text-uppercase">{{ "KEY.WHITE_AREA" | translate }}</span>
	</div>
	<div class="mb-3">
		<img
			class="key-image mr-4"
			src="{{ pathImgsMarkers }}/ico-rete-trasporto-legenda.png?v={{ assets_version }}"
			srcset="{{pathImgsMarkers}}/ico-rete-trasporto-legenda@2x.png 2x"
			alt=""
		/>
		<span class="key-text text-uppercase">{{ "KEY.NETWORK" | translate }}</span>
	</div>
	<div class="mb-3">
		<img class="key-image mr-4" src="{{ pathImgsMarkers }}/ico-prospect-map.png?v={{ assets_version }}" alt="" />
		<span class="key-text text-uppercase">{{ "KEY.PROSPECT" | translate }}</span>
	</div>
	<div class="mb-3">
		<img
			class="key-image mr-4"
			src="{{ pathImgsMarkers }}/ico-area-industriale.png?v={{ assets_version }}"
			alt=""
		/>
		<span class="key-text text-uppercase">{{ "KEY.INDUSTRIAL_AREA" | translate }}</span>
	</div>
	<div class="mb-3">
		<img class="key-image mr-4" src="{{ pathImgsMarkers }}/civic_marker_key.png?v={{ assets_version }}" alt="" />
		<span class="key-text text-uppercase">{{ "KEY.BUILDING" | translate }}</span>
	</div>
	<div class="mb-3">
		<img class="key-image mr-4" src="{{ pathImgsMarkers }}/marker_man_key.png?v={{ assets_version }}" alt="" />
		<span class="key-text text-uppercase">{{ "KEY.MAN" | translate }}</span>
	</div>
	<div class="mb-4">
		<img
			style="width: 22px; margin-right: 2rem"
			class="ml-2"
			src="{{ pathImgsMarkers }}/civic_marker_green_key.png?v={{ assets_version }}"
			alt=""
		/>
		<span class="key-text text-uppercase">Network available for PON & P2P Rural Area</span>
	</div>
	<div class="mb-3">
		<img class="ml-2 mr-4" src="{{ pathImgsMarkers }}/civic_marker_blue.png?v={{ assets_version }}" alt="" />
		<span class="key-text ml-2 text-uppercase">{{ "KEY.BUILDING_PROSPECT" | translate }}</span>
	</div>
	<div class="mb-3">
		<img class="key-image mr-4" src="{{ pathImgsMarkers }}/marker_man_key_blue.png?v={{ assets_version }}" alt="" />
		<span class="key-text text-uppercase">{{ "KEY.MAN_PROSPECT" | translate }}</span>
	</div>
	<div class="mb-3">
		<img
			style="height: 40px; max-width: 100%"
			class="ml-2 mr-4"
			src="{{ pathImgsMarkers }}/poi.png?v={{ assets_version }}"
			alt=""
		/>
		<span class="key-text text-uppercase ml-1">{{ "KEY.POINTS_INTEREST" | translate }}</span>
	</div>
</div>
